import { AxiosError, isAxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import DiscountCouponService from 'src/features/discountCoupons/data/service/DiscountCouponService';
import {
  ApplyCouponParams,
  CouponNotFoundResponse,
  GetCouponDetailParams,
  RemoveCouponParams,
} from 'src/features/discountCoupons/data/service/DiscountCouponService.types';
import { DiscountCouponRepositoryInterface } from 'src/features/discountCoupons/domain/DiscountCouponsRespository.types';

@injectable()
class DiscountCouponRepository implements DiscountCouponRepositoryInterface {
  @inject(DiscountCouponService)
  private readonly discountCouponService!: DiscountCouponService;

  private handleError(error: unknown) {
    if (isAxiosError(error)) {
      const axiosError = error as AxiosError<CouponNotFoundResponse>;
      if (axiosError.response?.status === 404) {
        throw Error('Cupón inválido');
      } else {
        console.error(error);
        throw Error('Ocurrió un error al aplicar el cupón');
      }
    } else {
      console.error(error);
      throw Error('Ocurrió un error al aplicar el cupón');
    }
  }

  public async applyToCart(params: ApplyCouponParams) {
    try {
      const response = await this.discountCouponService.applyToCart(params);

      return response.data.coupon_details;
    } catch (error) {
      this.handleError(error);
    }
  }

  public async removeFromCart(params: RemoveCouponParams) {
    try {
      const response = await this.discountCouponService.removeFromCart(params);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  public async getDetails(params: GetCouponDetailParams) {
    try {
      const response = await this.discountCouponService.getDetails(params);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}

export default DiscountCouponRepository;
